import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Template } from '../model/template';


@Injectable()
export class TemplatesService {

  constructor(
    private http: HttpClient
  ) { }

  private API_TEMPLATES = environment.API_BASE + '/Plantillas/GetOfRoute/{ROUTE}/{TEMPLATE_ID}';
  private API_TEMPLATES_BASE = environment.API_BASE + '/Plantillas';

  getTemplateFields(route: string, templateId: number): Observable<Template> {
    return this.http.get<Template>(this.API_TEMPLATES.replace('{ROUTE}', route).replace('{TEMPLATE_ID}', '' + templateId))
      .pipe(map((template: Template) => Template.toModel(JSON.stringify(template))));
  }

  getIdPlantillaInventario(idSerie: number): Observable<number> {
    return this.http.get<number>(this.API_TEMPLATES_BASE + '/GetPlantillaInventario?idSerie=' + idSerie);
  }

  getTemplateInventarioSerie(idSerie: number): Observable<Template> {
    return this.http.get<Template>(this.API_TEMPLATES_BASE + '/getPlantillaAndFields?idSerie=' + idSerie);
  }

}
